//토모플레이 - 본사 - 앱 통계 페이지
import React, { useState, useEffect, useCallback, forwardRef, useImperativeHandle, Component } from "react";

import ReactEcharts from "echarts-for-react";
import { format, addDays, addMonths, isSameMonth } from "date-fns";

import axios from "@app/lib/axios";

import CommonHorizontalBarChart from "@app/components/CommonHorizontalBarChart";
import AgGridReactEx from "@app/components/AgGridReactEx";

import PlayConstants from "@app/config/PlayConstants";
import playStyle from "../components/style";

const appConnectChartOption = {
    xAxis: { field: "statDate" },
    yAxis: {
        name: "건",
        series: playStyle.seriesPlayPlatformConnectChart,
    },
    stacks: [{ stack: "base", showPercent: true, showSum: false, showSumTooltip: true }],
    showLegend: true,
    legend: {
        x: "right",
        y: "top",
    },
    showSum: true,
    sort: false,
    grid: {
        top: "15%",
        left: "5%",
        right: "5%",
    },
};

const appTodayRunOption = {
    xAxis: { field: "statDate" },
    yAxis: {
        name: "건",
        series: playStyle.seriesTodayRunChart,
    },
    stacks: [{ stack: "base", showPercent: true, showSum: false, showSumTooltip: true }],
    showLegend: true,
    legend: {
        x: "right",
        y: "top",
    },
    showSum: true,
    sort: false,
    grid: {
        top: "15%",
        left: "5%",
        right: "5%",
    },
};

const appTodayStampOption = {
    xAxis: { field: "statDate" },
    yAxis: {
        name: "건",
        series: playStyle.seriesTodayStampChart,
    },
    stacks: [{ stack: "base", showPercent: true, showSum: false, showSumTooltip: true }],
    showLegend: true,
    legend: {
        x: "right",
        y: "top",
    },
    showSum: true,
    sort: false,
    grid: {
        top: "15%",
        left: "5%",
        right: "5%",
    },
};

const appReConnectOption = {
    xAxis: { field: "day" },
    yAxis: {
        name: "명",
        series: [{ name: "사용자 수", field: "user", stack: "base", showSum: true, option: { itemStyle: { color: "#60d7c5" } } }],
    },
    stacks: [{ stack: "base", showPercent: false, showSum: false, showSumTooltip: false }],
    showLegend: false,
    legend: {
        x: "right",
        y: "top",
    },
    showSum: false,
    sort: false,
    grid: {
        top: "15%",
        left: "5%",
        right: "5%",
    },
};
const appNewChartOption = {
    xAxis: { field: "statDate" },
    yAxis: {
        name: "건",
        series: [{ name: "앱 설치 수", field: "newUser", stack: "base", type: "line", option: { smooth: false, itemStyle: { color: "#5ab1ef" } } }],
    },
    stacks: [{ stack: "base", showPercent: false, showSum: false, showSumTooltip: false }],
    showLegend: true,
    legend: {
        x: "right",
        y: "top",
    },
    sort: false,
    grid: {
        top: "15%",
        left: "5%",
        right: "5%",
    },
};
const appAgeChartOption = {
    xAxis: { field: "statDate" },
    yAxis: {
        name: "건",
        series: [
            { name: "만3세", field: "age0Play", stack: "base0", showSum: false },
            { name: "만4세", field: "age1Play", stack: "base1", showSum: false },
            { name: "만5세", field: "age2Play", stack: "base2", showSum: false },
            { name: "혼합", field: "age3Play", stack: "base3", showSum: false },
        ],
    },
    stacks: [
        { stack: "base0", showSum: false },
        { stack: "base1", showSum: false },
        { stack: "base2", showSum: false },
        { stack: "base3", showSum: false },
    ],
    tooltipalign: "vertical",
    tooltipFormatter: (params, chart, test) => {
        var tooltipHtml = [""];
        var tooltipTitle = "";
        var total = 0;

        params.map((e) => {
            if (e.seriesName.indexOf("Sum-") < 0) {
                total += e.value;
            }
        });
        params.map((e) => {
            if (e.seriesName.indexOf("Sum-") < 0) {
                if (!tooltipTitle) tooltipTitle += e.name + `<br/>`;

                const stackIndex = 0;
                tooltipHtml[stackIndex] += e.marker + e.seriesName + " : " + (e.value ? e.value.toLocaleString() : "-");
                tooltipHtml[stackIndex] += total > 0 ? ` (` + Math.round((e.value / total) * 100) + "%)" : "";
                tooltipHtml[stackIndex] += "<br/>";
            }
        });
        var tooltip = tooltipTitle + '<div class="text-left">';
        tooltipHtml.forEach((t, index) => {
            tooltip += t;
        });
        tooltip += `<b>합계: ${total.toLocaleString()}</b>`;
        tooltip += `</div>`;

        return tooltip;
    },
    showLegend: true,
    legend: {
        x: "right",
        y: "top",
    },
    sort: false,
    grid: {
        top: "15%",
        left: "5%",
        right: "5%",
    },
};
const contentChartOption = {
    xAxis: { field: "statDate" },
    yAxis: {
        name: "건",
        series: [{ name: "실행 수", field: "playCount", stack: "base", option: { itemStyle: { color: "#5B9BD5" } } }],
    },
    stacks: [{ stack: "base", showSum: false, showSumTooltip: false }],
    tooltipFormatter: (params, chart, test) => {
        var tooltipTitle = "";
        var total = 0;
        params.map((e) => {
            if (e.seriesName.indexOf("Sum-") < 0) {
                tooltipTitle = e.name;
                total += e.value;
            }
        });

        var tooltip = tooltipTitle + '<div class="text-left">';
        tooltip += `<b>합계: ${total.toLocaleString()}</b>`;
        tooltip += `</div>`;

        return tooltip;
    },
    showLegend: false,
    legend: {
        x: "right",
        y: "top",
    },
    sort: false,
    grid: {
        top: "15%",
        left: "5%",
        right: "5%",
    },
};
const contentSumChartOption = {
    xAxis: { field: "statDate" },
    yAxis: {
        name: "건",
        series: [{ name: "실행 수", field: "playCountSum", stack: "base", option: { itemStyle: { color: "#5B9BD5" } } }],
    },
    stacks: [{ stack: "base", showPercent: true, showSum: false, showSumTooltip: true }],
    tooltipFormatter: (params, chart, test) => {
        var tooltipTitle = "";
        var total = 0;

        params.map((e) => {
            if (e.seriesName.indexOf("Sum-") < 0) {
                tooltipTitle = e.name;
                total += e.value;
            }
        });

        var tooltip = tooltipTitle + '<div class="text-left">';
        tooltip += `<b>합계: ${total.toLocaleString()}</b>`;
        tooltip += `</div>`;

        return tooltip;
    },
    showLegend: false,
    legend: {
        x: "right",
        y: "top",
    },
    sort: false,
    grid: {
        top: "15%",
        left: "5%",
        right: "5%",
    },
};

const parentJoinCount = {
    xAxis: { field: "statDate" },
    yAxis: {
        name: "건",
        series: [
            { name: "계약 원아 수", field: "contractCount", stack: "base0", showSum: false },
            { name: "등록 원아 수", field: "registCount", stack: "base1", showSum: false},
            { name: "초대수", field: "inviteCount", stack: "base2", showSum: false },
            { name: "프로필 수", field: "profileCount", stack: "base3", showSum: false },
            { name: "회원가입 수", field: "parentCount", stack: "base4", showSum: false },
        ],
    },
    stacks: [
        { stack: "base0", showSum: false },
        { stack: "base1", showSum: false },
        { stack: "base2", showSum: false },
        { stack: "base3", showSum: false },
        { stack: "base4", showSum: false },
    ],
    tooltipFormatter: (params, chart, test) => {
        var tooltipHtml = [""];
        var tooltipTitle = "";
        var total = params[0].value;;

        params.map((e) => {
            if (e.seriesName.indexOf("Sum-") < 0) {
                if (!tooltipTitle) tooltipTitle += e.name + `<br/>`;

                const stackIndex = 0;
                tooltipHtml[stackIndex] += e.marker + e.seriesName + " : " + (e.value ? e.value.toLocaleString() : "-");
                tooltipHtml[stackIndex] += total > 0 ? ` (` + ((e.value / total) * 100).toFixed(1) + "%)" : "";
                tooltipHtml[stackIndex] += "<br/>";
            }
        });
        var tooltip = tooltipTitle + '<div class="text-left">';
        tooltipHtml.forEach((t, index) => {
            tooltip += t;
        });
        tooltip += `<b>합계: ${total.toLocaleString()}</b>`;
        tooltip += `</div>`;

        return tooltip;
    },
    showLegend: true,
    legend: {
        x: "right",
        y: "top",
    },
    sort: false,
    grid: {
        top: "15%",
        left: "8%",
        right: "5%",
    },
};

const teacherJoinCount = {
    xAxis: { field: "statDate" },
    yAxis: {
        name: "건",
        series: [
            { name: "계약 반 수", field: "classCount", stack: "base0", showSum: false },
            { name: "회원가입 수", field: "teacherCount", stack: "base1", showSum: false },
        ],
    },
    stacks: [
        { stack: "base0", showSum: false },
        { stack: "base1", showSum: false },
    ],
    tooltipFormatter: (params, chart, test) => {
        var tooltipHtml = [""];
        var tooltipTitle = "";
        var total = params[0].value;

        params.map((e) => {
            if (e.seriesName.indexOf("Sum-") < 0) {
                if (!tooltipTitle) tooltipTitle += e.name + `<br/>`;

                const stackIndex = 0;
                tooltipHtml[stackIndex] += e.marker + e.seriesName + " : " + (e.value ? e.value.toLocaleString() : "-");
                tooltipHtml[stackIndex] += total > 0 ? ` (` + ((e.value / total) * 100).toFixed(1) + "%)" : "";
                tooltipHtml[stackIndex] += "<br/>";
            }
        });
        var tooltip = tooltipTitle + '<div class="text-left">';
        tooltipHtml.forEach((t, index) => {
            tooltip += t;
        });
        tooltip += `<b>합계: ${total.toLocaleString()}</b>`;
        tooltip += `</div>`;

        return tooltip;
    },
    showLegend: true,
    legend: {
        x: "right",
        y: "top",
    },
    sort: false,
    grid: {
        top: "15%",
        left: "8%",
        right: "5%",
    },
};

const StatDevice = ({ type, statAndroid, statIos }) => {
    const defaultColDef = {
        editable: false,
        sortable: true,
        flex: 1,
        minWidth: 60,
        filter: false,
        resizable: true,
        cellClass: "text-center",
        headerClass: "bg-dark text-light",
    };

    let typeName = "OS";
    let typeField = "platformVersion";
    if (type === "app") {
        typeName = "앱";
        typeField = "appVersion";
    }
    const listColumn = [
        {
            headerName: typeName + " 버전",
            field: typeField,
            minWidth: 80,
        },
        {
            headerName: "사용자 수",
            field: "cnt",
            minWidth: 70,
            cellRenderer: (param) => {
                return param.value ? param.value.toLocaleString() : "-";
            },
        },
        {
            headerName: "비율",
            field: "rate",
            minWidth: 70,
            sort: "desc",
            cellRenderer: (param) => {
                return param.value ? param.value.toFixed(1).toLocaleString() + "%" : "-";
            },
        },
    ];

    return (
        <div className="row">
            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                <div className="panel">
                    <span className="h6 text-left">-AOS-</span>
                    {statAndroid && statAndroid.length > 0 ? (
                        <AgGridReactEx height={230} defaultColDef={defaultColDef} columnDefs={listColumn} rowData={statAndroid} />
                    ) : (
                        <div style={{ textAlign: "center", height: "230px", lineHeight: "230px" }} className="align-items-center">
                            통계 자료가 없습니다.
                        </div>
                    )}
                </div>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                <div className="panel">
                    <span className="h6">-iOS-</span>
                    {statIos && statIos.length > 0 ? (
                        <AgGridReactEx height={230} defaultColDef={defaultColDef} columnDefs={listColumn} rowData={statIos} />
                    ) : (
                        <div style={{ textAlign: "center", height: "230px", lineHeight: "230px" }} className="align-items-center">
                            통계 자료가 없습니다.
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

const CategoryTable = ({ menu, data }) => {
    const defaultColDef = {
        editable: false,
        sortable: true,
        flex: 1,
        minWidth: 90,
        maxWidth: 110,
        filter: false,
        resizable: true,
        cellClass: "text-center",
        headerClass: "bg-dark text-light",
    };
    const listColumn = [{ headerName: " ", field: "count", minWidth: 70 }];
    const statCount = { count: "순 실행 수" };
    const statCountSum = { count: "누적 실행 수" };
    const statCategory = [];
    if (data) {
        data.map((element) => {
            listColumn.push({
                headerName: element.subCategory,
                field: element.subCategory,
                minWidth: 90,
            });

            statCount[element.subCategory] = element.playCount ? element.playCount : 0;
            statCountSum[element.subCategory] = element.playCountSum ? element.playCountSum : 0;
        });
        statCategory.push(statCount);
        statCategory.push(statCountSum);
    }
    return (
        <div>
            <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                {menu != "• all" ? menu : null}
            </div>
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <div className="panel" style={{ width: 110 * listColumn.length, maxWidth: "100%" }}>
                    {statCategory && statCategory.length > 0 ? (
                        <AgGridReactEx height={115} defaultColDef={defaultColDef} columnDefs={listColumn} rowData={statCategory} />
                    ) : (
                        <div style={{ textAlign: "center", height: "110px", lineHeight: "110px" }} className="align-items-center">
                            통계 자료가 없습니다.
                        </div>
                    )}
                    &nbsp;
                </div>
            </div>
        </div>
    );
};

const App = forwardRef(({ statPeriod }, ref) => {
    const [statApp, setStatApp] = useState(false);
    const [statAppAge, setStatAppAge] = useState(false);
    const [statContent, setStatContent] = useState(false);
    const [statContentSum, setStatContentSum] = useState(false);
    const [statNewUserOs, setStatNewUserOs] = useState(false);
    const [statDeviceVersion, setStatDevice] = useState(false);
    const [statAppVersion, setStatAppVersion] = useState(false);
    const [statDeviceAndroid, setStatDeviceAndroid] = useState(false);
    const [statDeviceIos, setStatDeviceIos] = useState(false);
    const [statAppAndroid, setStatAppAndroid] = useState(false);
    const [statAppIos, setStatAppIos] = useState(false);
    const [statReconnect, setReconnect] = useState(false);
    const [statTodayRun, setTodayRun] = useState(false);
    const [statTodayStamp, setTodayStamp] = useState(false);
    const [statJoinCount, setJoinCount] = useState(false);
    const [statMenuCount, setMenuCount] = useState(false);
    const [path, setPath] = useState(
        PlayConstants.HOME.EXECUTE_PATH.map((gp) => {
            return { name: gp.name, field: `cnt${gp.id}`, stack: "base" };
        })
    );

    const appNewUserOsChartContent = {
        tooltip: {
            trigger: "item",
            formatter: (param) => {
                return param.data ? param.data.name + " : " + param.data.value.toLocaleString() + " (" + Math.ceil(param.percent) + "%)" : "";
            },
        },
        series: [
            {
                type: "pie",
                data: statNewUserOs,
                radius: ["0%", "95%"],
                animation: false,
                center: ["50%", "50%"],
                labelLine: {
                    show: false,
                },
                label: {
                    show: false,
                    position: "center",
                },
                color: ["#60d7c5", "#3861a5"],
            },
        ],
        legend: {
            x: "right",
            y: "top",
        },
        sort: false,
        grid: {
            top: "15%",
            left: "5%",
            right: "5%",
        },
    };

    useImperativeHandle(ref, () => ({
        getExcelData(callback) {
            var count = [];
            var categoryCount = [...statMenuCount];
            categoryCount.map((s) => {
                s.splice(0, 0, { subCategory: "", playCount: "순 실행 수", playCountSum: "누적 실행 수" });
                count.push(s.map((v) => v.playCount));
                count.push(s.map((v) => v.playCountSum));
            });
            const excelData = {
                fileName: "토모플레이_앱통계",
                sheets: [
                    { name: "접속", title: "접속 수 통계", columnTitle: ["", "Android", "iOS"], data: statApp ? statApp.map((s) => [s.statDate, s.connectAndroid, s.connectIos]) : [] },
                    { name: "이용자 접속일수", title: "이용자 접속일수 통계", columnTitle: ["", "사용자 수"], data: statReconnect ? statReconnect.map((s) => [s.day, s.user]) : [] },
                    {
                        name: "학부모 가입 현황",
                        title: "학부모 가입 현황",
                        columnTitle: ["", "계약 원아 수", "초대수", "프로필 수", "회원가입 수"],
                        data: statJoinCount ? statJoinCount.map((s) => [s.statDate, s.contractCount, s.inviteCount, s.profileCount, s.parentCount]) : [],
                    },
                    {
                        name: "교사 가입 현황",
                        title: "교사 가입 현황",
                        columnTitle: ["", "계약 반 수", "회원가입 수"],
                        data: statJoinCount ? statJoinCount.map((s) => [s.statDate, s.classCount, s.teacherCount]) : [],
                    },
                    {
                        name: "연령",
                        title: "연령별 사용량 통계",
                        columnTitle: ["", "만3세", "만4세", "만5세", "혼합"],
                        data: statAppAge ? statAppAge.map((s) => [s.statDate, s.age0Play, s.age1Play, s.age2Play, s.age3Play]) : [],
                    },
                    { name: "설치", title: "앱 설치 수 통계", columnTitle: ["", "안드로이드", "IOS"], data: statApp ? statApp.map((s) => [s.statDate, s.newUserAndroid ? s.newUserAndroid : 0, s.newUserIos ? s.newUserIos : 0]) : [] },
                    {
                        name: "OS",
                        title: "OS별 사용자 통계",
                        columnTitle: ["OS", "OS 버전", "사용자 수"],
                        data: statDeviceVersion ? statDeviceVersion.map((s) => [s.platform, s.platformVersion, s.cnt]) : [],
                    },
                    {
                        name: "앱",
                        title: "앱별 사용자 통계",
                        columnTitle: ["앱", "앱 버전", "사용자 수"],
                        data: statAppVersion ? statAppVersion.map((s) => [s.platform, s.appVersion, s.cnt]) : [],
                    },

                    {
                        name: "콘텐츠(순)",
                        title: "콘텐츠 순 실행 통계",
                        columnTitle: ["", "콘텐츠 순 실행 수"],
                        data: statContent ? statContent.map((s) => [s.statDate, s.playCount]) : [],
                    },
                    {
                        name: "콘텐츠(누적)",
                        title: "콘텐츠 누적 실행 통계",
                        columnTitle: ["", "콘텐츠 누적 실행 수"],
                        data: statContent ? statContent.map((s) => [s.statDate, s.playCountSum]) : [],
                    },
                    {
                        name: "오늘토모랑 이용 현황 (실행콘텐츠 수 기준)",
                        title: "오늘토모랑 이용 현황",
                        columnTitle: ["", "당일실행", "당일제외실행", "모두보기/보관함"],
                        data: statTodayRun ? statTodayRun.map((s) => [s.statDate, s.todayRun, s.notTodayRun, s.etc]) : [],
                    },
                    {
                        name: "오늘토모랑 이용자수 현황 (월별|인원 기준)",
                        title: "오늘토모랑 이용자수 현황",
                        columnTitle: ["", "1회~5회", "6회~10회", "11회~15회", "16회~20회"],
                        data: statTodayStamp ? statTodayStamp.map((s) => [s.statDate, s.five, s.ten, s.fifty, s.twenty]) : [],
                    },
                    {
                        name: "카테고리별 실행 수",
                        title: "카테고리별 실행 수",
                        columnTitle: categoryCount[0] && categoryCount[0].map((s) => s.subCategory),
                        data: [count[0], count[1]],
                    },
                    {
                        name: "모모한글 실행 수",
                        title: "모모한글 실행 수",
                        columnTitle: categoryCount[1] && categoryCount[1].map((s) => s.subCategory),
                        data: [count[2], count[3]],
                    },
                    {
                        name: "모모수학 실행 수",
                        title: "모모수학 실행 수",
                        columnTitle: categoryCount[2] && categoryCount[2].map((s) => s.subCategory),
                        data: [count[4], count[5]],
                    },
                    {
                        name: "영어 실행 수",
                        title: "영어 실행 수",
                        columnTitle: categoryCount[3] && categoryCount[3].map((s) => s.subCategory),
                        data: [count[6], count[7]],
                    },
                    {
                        name: "한자 실행 수",
                        title: "한자 실행 수",
                        columnTitle: categoryCount[4] && categoryCount[4].map((s) => s.subCategory),
                        data: [count[8], count[9]],
                    },
                    {
                        name: "창의·인성 실행 수",
                        title: "창의·인성 실행 수",
                        columnTitle: categoryCount[4] && categoryCount[5].map((s) => s.subCategory),
                        data: [count[10], count[11]],
                    },
                    {
                        name: "체험놀이 실행 수",
                        title: "체험놀이 실행 수",
                        columnTitle: categoryCount[5] && categoryCount[6].map((s) => s.subCategory),
                        data: [count[12], count[13]],
                    },
                    {
                        name: "안전 실행 수",
                        title: "안전 실행 수",
                        columnTitle: categoryCount[7] && categoryCount[7].map((s) => s.subCategory),
                        data: [count[14], count[15]],
                    },
                    {
                        name: "누리활동 실행 수",
                        title: "누리활동 실행 수",
                        columnTitle: categoryCount[8] && categoryCount[8].map((s) => s.subCategory),
                        data: [count[16], count[17]],
                    },
                    {
                        name: "별별책방 실행 수",
                        title: "별별책방 실행 수",
                        columnTitle: categoryCount[9] && categoryCount[9].map((s) => s.subCategory),
                        data: [count[18], count[19]],
                    },
                    {
                        name: "오디오북 실행 수",
                        title: "오디오북 실행 수",
                        columnTitle: categoryCount[10] && categoryCount[10].map((s) => s.subCategory),
                        data: [count[20], count[21]],
                    },
                    {
                        name: "동요 실행 수",
                        title: "동요 실행 수",
                        columnTitle: categoryCount[11] && categoryCount[11].map((s) => s.subCategory),
                        data: [count[22], count[23]],
                    },
                ],
            };
            callback(null, excelData);
        },
    }));

    const getStat = useCallback(() => {
        axios({
            method: "POST",
            url: `/api/play_stat/play/app`,
            data: {
                startDate: statPeriod.startDate,
                endDate: statPeriod.endDate,
                limit: 5,
                periodType: statPeriod.type,
            },
        })
            .then((result) => {
                if (result.data.code === 200) {
                    const stat = result.data.data;
                    let statApp = [];
                    let statAppAge = [];
                    let statDevice = [];
                    let statTodayRun = [];
                    let statDeviceAndroid = null;
                    let statDeviceIos = null;
                    let statAppAndroid = null;
                    let statAppIos = null;
                    let statContent = [];
                    let statContentSum = [];
                    let statPathTemp = [];
                    let statJoinCount = [];
                    let statTodayStamp = [];
                    let statNewUserOs = [
                        { id: 0, name: "Android", value: 0 },
                        { id: 1, name: "iOS", value: 0 },
                    ];

                    let pathNullExist = false;
                    if (stat.path && stat.path.length > 0) {
                        stat.path.forEach((s) => {
                            const group = FlyEngConstants.HOME.EXECUTE_PATH.find((ep) => s.path.indexOf(ep.groupPath) === 0);
                            if (group) {
                                const cntPath = `cnt${group.id}`;
                                const path = statPathTemp.find((sp) => sp.statDate == s.statDate);
                                if (path) {
                                    path[cntPath] = (path[cntPath] || 0) + s.cnt;
                                } else {
                                    const pathNew = { statDate: s.statDate };
                                    pathNew[cntPath] = s.cnt;
                                    statPathTemp.push(pathNew);
                                }
                                if (group.id < 0) {
                                    pathNullExist = true;
                                }
                            }
                        });
                    }
                    if (pathNullExist) {
                        const pathNew = path.shift();
                        setPath(pathNew);
                    }

                    stat.todayStamp.map((s) => {
                        var date = s.month.toString();
                        s.month = date.slice(0, 4) + "-" + date.slice(4, 6);
                    });

                    let start = new Date(statPeriod.startDate);
                    let day = new Date(statPeriod.startDate);
                    for (let i = 0; i < 99; i++) {
                        const statDate = format(day, statPeriod.type === "year" ? "yyyy-MM" : "yyyy-MM-dd");
                        const statDateStr = format(day, statPeriod.type === "year" ? "yyyy-MM" : "MM-dd");
                        const sTodayRun = stat.todayRun.find((s) => s.statDate === statDate);
                        const sApp = stat.app.find((s) => s.statDate === statDate);
                        const sAge = stat.appAge.find((s) => s.statDate === statDate);
                        const sContent = stat.content.find((s) => s.statDate === statDate);
                        const sJoinCount = stat.joinCount.findLast((s) => s.statDate === statDate);

                        if (sApp) {
                            sApp.newUser = (sApp.newUserAndroid || 0) + (sApp.newUserIos || 0);
                            statNewUserOs[0].value += sApp.newUserAndroid || 0;
                            statNewUserOs[1].value += sApp.newUserIos || 0;
                        }

                        statJoinCount.push({ ...sJoinCount, statDate: statDateStr });
                        statTodayRun.push({ ...sTodayRun, statDate: statDateStr });
                        statApp.push({ ...sApp, statDate: statDateStr });
                        statAppAge.push({ ...sAge, statDate: statDateStr });
                        statContent.push({ ...sContent, statDate: statDateStr });
                        if (statPeriod.type === "week") {
                            day = addDays(day, 1);
                            if (i >= 6) break;
                        } else if (statPeriod.type === "month") {
                            day = addDays(day, 1);
                            if (!isSameMonth(day, start)) break;
                        } else {
                            // year
                            day = addMonths(day, 1);
                            if (i > 11) break;
                        }
                    }

                    var today = new Date();
                    var year = today.getFullYear() < 3 ? today.getFullYear() - 1 : today.getFullYear();
                    for (let i = 3; i < 13; i++) {
                        var statMonth = (i < 3 ? year + 1 : year) + "-" + (i < 10 ? "0" + i : i);
                        const sTodayStamp = stat.todayStamp.find((s) => s.month == statMonth);
                        statTodayStamp.push({ ...sTodayStamp, statDate: statMonth });
                        if (i == 12) i = 0;
                        if (i == 2) break;
                    }

                    statDeviceAndroid = stat.deviceVersion.filter((d) => d.platform == "android");
                    if (statDeviceAndroid.length > 0) {
                        const total = statDeviceAndroid.reduce((ac, s) => ac + (s.cnt ? s.cnt : 0), 0);
                        statDeviceAndroid.forEach((s) => (s.rate = (s.cnt / total) * 100));
                    }
                    statDeviceIos = stat.deviceVersion.filter((d) => d.platform == "ios");
                    if (statDeviceIos.length > 0) {
                        const total = statDeviceIos.reduce((ac, s) => ac + (s.cnt ? s.cnt : 0), 0);
                        statDeviceIos.forEach((s) => (s.rate = (s.cnt / total) * 100));
                    }
                    statAppAndroid = stat.appVersion.filter((d) => d.platform == "android");
                    if (statAppAndroid.length > 0) {
                        const total = statAppAndroid.reduce((ac, s) => ac + (s.cnt ? s.cnt : 0), 0);
                        statAppAndroid.forEach((s) => (s.rate = (s.cnt / total) * 100));
                    }
                    statAppIos = stat.appVersion.filter((d) => d.platform == "ios");
                    if (statAppIos.length > 0) {
                        const total = statAppIos.reduce((ac, s) => ac + (s.cnt ? s.cnt : 0), 0);
                        statAppIos.forEach((s) => (s.rate = (s.cnt / total) * 100));
                    }

                    // //이용자 접속 일수 테스트 추가 데이터
                    // stat.reconnect.push({year: 2023, day: 65, user:900})
                    // stat.reconnect.push({year: 2023, day: 155, user:2500})

                    for (let i = 0; i < 10; i++) {
                        if (stat.reconnect[i] == undefined || stat.reconnect[i].day != i + 1) {
                            stat.reconnect.splice(i, 0, { day: i + 1 + "일", user: 0 });
                        } else {
                            stat.reconnect[i].day = stat.reconnect[i].day + "일";
                        }
                    }
                    var reconnect = stat.reconnect.slice(0, 10);

                    const sliceUser = (start, end, plus) => {
                        for (let i = start; i < end; i += plus) {
                            var range = stat.reconnect.filter((runDate) => i < runDate.day && runDate.day <= i + plus);
                            var total = 0;
                            range.map((m) => {
                                total += m.user;
                            });
                            reconnect.push({ day: i + 1 + "~" + (i + plus) + "일", user: total });
                        }
                    };

                    if (stat.reconnect[stat.reconnect.length - 1].day > 10) sliceUser(10, 50, 5);
                    if (stat.reconnect[stat.reconnect.length - 1].day > 50) sliceUser(50, 100, 10);
                    if (stat.reconnect[stat.reconnect.length - 1].day > 100) {
                        sliceUser(100, 300, 50);
                        sliceUser(300, 400, 100);
                        reconnect[reconnect.length - 1].day = "300일~";
                    }

                    var menu = "first";
                    var count = 0;
                    var countSum = 0;
                    var menuCount = [[]];
                    var number = 0;
                    stat.contentCategory.map((s) => {
                        if (s.menu == menu) {
                            menuCount[0].pop();
                            count += s.playCount;
                            countSum += s.playCountSum;
                            menuCount[0].push({ menu: "all", subCategory: s.menu, playCount: count ? count : 0, playCountSum: countSum ? countSum : 0 });
                            menuCount[number].push({ menu: s.menu, subCategory: s.subCategory, playCount: s.playCount ? s.playCount : 0, playCountSum: s.playCountSum ? s.playCountSum : 0 });
                        } else {
                            number++;
                            menu = s.menu;
                            menuCount[0].push({ menu: "all", subCategory: s.menu, playCount: s.playCount ? s.playCount : 0, playCountSum: s.playCountSum ? s.playCountSum : 0 });
                            count = s.playCount;
                            countSum = s.playCountSum;
                            menuCount.push([{ menu: s.menu, subCategory: s.subCategory, playCount: s.playCount ? s.playCount : 0, playCountSum: s.playCountSum ? s.playCountSum : 0 }]);
                        }
                    });

                    setMenuCount(menuCount);
                    setJoinCount(statJoinCount);
                    setTodayStamp(statTodayStamp);
                    setTodayRun(statTodayRun);
                    setReconnect(reconnect);
                    setStatDevice(stat.deviceVersion);
                    setStatAppVersion(stat.appVersion);
                    setStatApp(statApp);
                    setStatAppAge(statAppAge);
                    setStatNewUserOs(statNewUserOs);
                    setStatDeviceAndroid(statDeviceAndroid);
                    setStatDeviceIos(statDeviceIos);
                    setStatAppAndroid(statAppAndroid);
                    setStatAppIos(statAppIos);
                    setStatContent(statContent);
                } else {
                    alert(result.data && result.data.msg ? result.data.msg : "통계 정보를 가져오는데 실패하였습니다.\n지속 발생시 관리자에게 문의해주세요.");
                }
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    }, [statPeriod]);
    useEffect(() => {
        getStat();

        return () => {};
    }, [getStat]);
    return (
        <div className="w-100">
            <div className="row">
                <div className="col">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h4 className="card-header-title">접속 수</h4>
                        </div>
                        <div className="card-body" style={{ height: "300px" }}>
                            <CommonHorizontalBarChart chartData={statApp} chartOption={appConnectChartOption} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h4 className="card-header-title">이용자 접속일수</h4>
                        </div>
                        <div className="card-body" style={{ height: "300px" }}>
                            <CommonHorizontalBarChart chartData={statReconnect} chartOption={appReConnectOption} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h4 className="card-header-title">학부모 가입 현황</h4>
                        </div>
                        <div className="card-body" style={{ height: "300px", padding: "5px 20px" }}>
                            <CommonHorizontalBarChart chartData={statJoinCount} chartOption={parentJoinCount} />
                        </div>
                    </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h4 className="card-header-title">교사 가입 현황</h4>
                        </div>
                        <div className="card-body" style={{ height: "300px", padding: "5px 20px" }}>
                            <CommonHorizontalBarChart chartData={statJoinCount} chartOption={teacherJoinCount} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h4 className="card-header-title">연령별 사용량</h4>
                        </div>
                        <div className="card-body" style={{ height: "300px" }}>
                            <CommonHorizontalBarChart chartData={statAppAge} chartOption={appAgeChartOption} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h4 className="card-header-title">설치 수</h4>
                        </div>
                        <div className="card-body" style={{ height: "300px" }}>
                            <CommonHorizontalBarChart chartData={statApp} chartOption={appNewChartOption} />
                        </div>
                    </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h4 className="card-header-title">OS별 설치 비율</h4>
                        </div>
                        <div className="card-body" style={{ height: "300px" }}>
                            <ReactEcharts theme="macarons" style={{ width: "100%", height: "100%" }} option={appNewUserOsChartContent} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h4 className="card-header-title">OS 버전별 사용자 수</h4>
                        </div>
                        <div className="card-body" style={{ height: "300px" }}>
                            <StatDevice type={"device"} statAndroid={statDeviceAndroid} statIos={statDeviceIos} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h4 className="card-header-title">앱 버전별 사용자 수</h4>
                        </div>
                        <div className="card-body" style={{ height: "300px" }}>
                            <StatDevice type={"app"} statAndroid={statAppAndroid} statIos={statAppIos} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h4 className="card-header-title">콘텐츠 순 실행 수</h4>
                        </div>
                        <div className="card-body" style={{ height: "300px" }}>
                            <CommonHorizontalBarChart chartData={statContent} chartOption={contentChartOption} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h4 className="card-header-title">콘텐츠 누적 실행 수</h4>
                        </div>
                        <div className="card-body" style={{ height: "300px" }}>
                            <CommonHorizontalBarChart chartData={statContent} chartOption={contentSumChartOption} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h4 className="card-header-title">오늘토모랑 이용 현황 (실행콘텐츠 수 기준)</h4>
                        </div>
                        <div className="card-body" style={{ height: "300px" }}>
                            <CommonHorizontalBarChart chartData={statTodayRun} chartOption={appTodayRunOption} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h4 className="card-header-title">오늘토모랑 이용자수 현황 (월별/인원 기준)</h4>
                        </div>
                        <div className="card-body" style={{ height: "300px" }}>
                            <CommonHorizontalBarChart chartData={statTodayStamp} chartOption={appTodayStampOption} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h4 className="card-header-title">카테고리별 콘텐츠 실행 수</h4>
                        </div>
                        {statMenuCount &&
                            statMenuCount.map((s) => {
                                return (
                                    <div key={s.menu}>
                                        <CategoryTable menu={"• " + s[0].menu} data={s} />
                                    </div>
                                );
                            })}
                    </div>
                </div>
            </div>
        </div>
    );
});

export default App;
